<template>
  <div>
    <img class="cursor-pointer" @click="clickLogin" src="@/assets/img/line.png" alt="line" />
  </div>
</template>

<script>
import thirdpartyLoginKey from '@/thirdpartyLoginKey.js'; // @第三方登入: 統一賦予第三方登入註冊服務要用的應用 key 值
export default {
  name: 'LineLogin',
  methods: {
    // @第三方登入
    clickLogin() {
      // 將所需參數拼成網址跳轉, 再由開發平台上頻道設定的Callback跳轉, Callback路徑需與下方參數redirectUri相同, 否則會錯誤
      let url = 'https://access.line.me/oauth2/v2.1/authorize'; // API網址, 取得使用者Code
      const clienId = thirdpartyLoginKey.LINE_CLIENT_ID; // 開發平台對應的頻道ID
      // const redirectUri = 'https://gawbue.lale.im/gawbueVue/index.html#/home/'; // 網址不可帶#字會造成API誤判致使錯誤
      const redirectUri = thirdpartyLoginKey.REDIRECT_URI;// 本地端測試用
      const scope = 'profile%20openid'; // 參照文件, 目前設定為取用戶資訊, ID Token, 無信箱
      url += '?response_type=code'; // 固定
      url += '&client_id=' + clienId;
      url += '&redirect_uri=' + redirectUri;
      url += '&state=line'; // state應亂數產生避免偽造, 現為方便辨認由何種平台故填line
      url += '&scope=' + scope;
      console.log('我是URL',url);
      window.location.href = url;
    }
  }
};
</script>

<style></style>
